/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Accountsync {
    angular.module("meevo.plugins.accountsync", []);
}